module.exports = __webpack_public_path__ + "static/media/k12_business-card_back_2x.875c41ca.jpg";